import { render } from "./CourseLogistics.vue?vue&type=template&id=8d4e0656&scoped=true"
import script from "./CourseLogistics.vue?vue&type=script&lang=js"
export * from "./CourseLogistics.vue?vue&type=script&lang=js"

import "./CourseLogistics.vue?vue&type=style&index=0&id=8d4e0656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4e0656"]])

export default __exports__